export default [

     {
          path: '/risk-affected-party',
          name: 'RiskAffectedParty',
          component: () => import("@/views/Page/RiskAffectedParty/RiskAffectedParty.vue"),
          meta: {
               title: 'Risk Affected Party',
          },
     }
];